import moment from 'moment'
import classNames from 'classnames'
import { cityType } from './loc';

export function fixedZero(val) {
  return val * 1 < 10 ? `0${val}` : val;
}

export function isObject(obj) {
  return Object.prototype.toString.call(obj)==='[object Object]';
}

export function isArray(arr){
  return Object.prototype.toString.call(arr)==='[object Array]';
};
// 账号数据
export const statisticOptionalMetrics = [
  'exposure',
  'click',
  'ctr',
  'avgClickPrice',
  'ecpm',
  'otherEffectValue1',
  'otherEffectValue2',
  'otherEffectValue3',
  'downloadStartCnt',
  'costPerDownloadStart',
  'downloadStartPerClick',
  'downloadFinishCnt',
  'costPerDownloadFinish',
  'downloadFinishPerStart',
  'installFinishCnt',
  'costPerInstallFinish',
  'installFinishPerDownload',

  'effectPerClick',
  'effectPerExposure',
]
// 数据趋势  下拉列表
export const chartOptionalMetrics = [
  'cost',
  'exposure',
  'click',
  'ctr',
  'avgClickPrice',
  'ecpm',
  'downloadStartCnt',
  'costPerDownloadStart',
  'downloadStartPerClick',
  'downloadFinishCnt',
  'costPerDownloadFinish',
  'downloadFinishPerStart',
  'installFinishCnt',
  'costPerInstallFinish',
  'installFinishPerDownload',
  'effectCnt',
  'costPerEffect',
  'effectPerClick',
  'effectPerExposure',
  'activationCnt',
  'costPerActivation',
  'activationPerClick',
  'registerCnt',
  'costPerRegister',
  'registerPerClick',
  'payCnt',
  'firstPayCnt',
  'firstPayRate',
  'firstPayPrice',
  'firstDayPay',
  'firstDayPayRate',
  'firstDayPayAmount',
  'firstDayPayRoi',
  'costPerPay',
  'payPerClick',
  'orderCnt',
  'addCardCnt',
  'otherEffectCnt',
  'costPerOtherEffect',
  'otherEffectPerClick',
  'formSubmitCnt',
  'costPerFormSubmit',
  'formSubmitPerClick',
  'wechatCopyCnt',
  'costPerWechatCopy',
  'wechatCopyPerClick',
  'webPay',
  'costPerWebPay',
  'webPayPerClick',
  'validConsultAcquireCnt',
  'phoneCallCnt',
  'webVisitCnt',
  'goodsBuyCnt',
  'validConsultCnt',
  'webOtherCnt',
  'costPerWebOther',
  'webOtherPerClick',
  'appInnerVisitCnt',
  'appDetailPageUVCnt',
  'effectMoney',
  'effectMoneyPerCost',
  'nextDayRetention',
  'nextDayRetentionRate',
  'sevenDaysRetention',
  'sevenDaysRetentionRate',
  'otherEffectValue1',
  'otherEffectValue2',
  'otherEffectValue3',
  'wechatActivate',
  'wechatActivateRate',
  'wechatActivatePrice',
  'wechatRegister',
  'wechatRegisterRate',
  'wechatRegisterPrice',
  'wechatPay',
  'wechatPayRate',
  'wechatPayPrice',
  'wechatPayAmount',
  'wechatPayRoi',
  'wechatFirstPay',
  'wechatFirstPayRate',
  'wechatFirstPayPrice',
  'wechatFirstDayPay',
  'wechatFirstDayPayRate',
  'wechatFirstDayPayAmount',
  'wechatFirstDayPayRoi',
  'wechatNextDayRetention',
  'wechatNextDayRetentionRate',
  'wechatSevenDaysRetention',
  'wechatSevenDaysRetentionRate',
  'wechatGamesRoleCreate',
  'wechatGamesRoleCreateRate',
  'wechatGamesRoleCreatePrice',
  'wechatOther',
  'wechatOtherRate',
  'wechatOtherPrice',
]

export function equals(oldData,newData){
  if(oldData === newData) return true;
  if(isObject(oldData)&&isObject(newData)&&Object.keys(oldData).length === Object.keys(newData).length){
      for (const key in oldData) {
          // eslint-disable-next-line no-prototype-builtins
          if (oldData.hasOwnProperty(key)) {
              if(!equals(oldData[key],newData[key]))
                  return false;
          }
      }
  }else if(isArray(oldData)&&isArray(oldData)&&oldData.length===newData.length){
      // eslint-disable-next-line prefer-destructuring
      for (let i = 0,length=oldData.length; i <length; i++) {
          if(!equals(oldData[i],newData[i]))
          return false;
      }
  }else{
      return false;
  }
  return true;
};

export function getTimeDuration(monA,monB) {
  const start = typeof monA === 'number' ? moment(monA) : monA;
  const end = typeof monB === 'number' ? moment(monB) : monB;
  return moment.duration(end.diff(start)).asDays();
}

export function getDisabledDate(current) {
  return current && current > moment().endOf('day')
}

export function range(start, end) {
  const result = [];
  for (let i = start; i < end; i++) {
    result.push(i);
  }
  return result;
}

export function getTimeDistance(type) {
  const now = new Date();
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const oneDay = 1000 * 60 * 60 * 24;

  if (type === 'today') {
    return [moment(today), moment(today.getTime() + (oneDay - 1000))];
  }

  if (type === 'yesterday') {
    const beginTime = today.getTime() - (1 * oneDay);

    return [moment(beginTime), moment(beginTime + ((1 * oneDay) - 1000))];
  }

  if (type === 'last7Days') {
    const beginTime = today.getTime() - (7 * oneDay);

    return [moment(beginTime), moment(beginTime + ((7 * oneDay) - 1000))];
  }

  if (type === 'last7DaysToday') {
    const beginTime = today.getTime() - (6 * oneDay);

    return [moment(beginTime), moment(beginTime + ((6 * oneDay)))];
  }

  if (type === 'last30Days') {
    const beginTime = today.getTime() - (30 * oneDay);

    return [moment(beginTime), moment(beginTime + ((30 * oneDay) - 1000))];
  }

  if (type === 'last90Days') {
    const beginTime = today.getTime() - (90 * oneDay);

    return [moment(beginTime), moment(beginTime + ((90 * oneDay) - 1000))];
  }

  if (type === 'week') {
    let day = today.getDay();

    if (day === 0) {
      day = 6;
    } else {
      day -= 1;
    }

    const beginTime = today.getTime() - (day * oneDay);

    return [moment(beginTime), moment(beginTime + ((7 * oneDay) - 1000))];
  }

  if (type === 'month') {
    const year = now.getFullYear();
    const month = now.getMonth();
    const nextDate = moment(now).add(1, 'months');
    const nextYear = nextDate.year();
    const nextMonth = nextDate.month();

    return [moment(`${year}-${fixedZero(month + 1)}-01 00:00:00`), moment(moment(`${nextYear}-${fixedZero(nextMonth + 1)}-01 00:00:00`).valueOf() - 1000)];
  }

  if (type === 'year') {
    const year = now.getFullYear();

    return [moment(`${year}-01-01 00:00:00`), moment(`${year}-12-31 23:59:59`)];
  }
}

export function getPlainNode(nodeList, parentPath = '') {
  const arr = [];
  nodeList.forEach((node) => {
    const item = node;
    item.path = `${parentPath}/${item.path || ''}`.replace(/\/+/g, '/');
    item.exact = true;
    if (item.children && !item.component) {
      arr.push(...getPlainNode(item.children, item.path));
    } else {
      if (item.children && item.component) {
        item.exact = false;
      }
      arr.push(item);
    }
  });
  return arr;
}

export const TITLE_LIST = {
  1: '计划',
  2: '广告',
  3: '创意',
  4: '搜索条件',
}

export function digitUppercase(n) {
  const fraction = ['角', '分'];
  const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖'];
  const unit = [
    ['元', '万', '亿'],
    ['', '拾', '佰', '仟'],
  ];
  let num = Math.abs(n);
  let s = '';
  fraction.forEach((item, index) => {
    s += (digit[Math.floor(num * 10 * (10 ** index)) % 10] + item).replace(/零./, '');
  });
  s = s || '整';
  num = Math.floor(num);
  for (let i = 0; i < unit[0].length && num > 0; i += 1) {
    let p = '';
    for (let j = 0; j < unit[1].length && num > 0; j += 1) {
      p = digit[num % 10] + unit[1][j] + p;
      num = Math.floor(num / 10);
    }
    s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s;
  }

  return s.replace(/(零.)*零元/, '元').replace(/(零.)+/g, '零').replace(/^整$/, '零元整');
}
/* eslint no-useless-escape:0 */
const reg = /(((^https?:(?:\/\/)?)(?:[-;:&=\+\$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=\+\$,\w]+@)[A-Za-z0-9.-]+)((?:\/[\+~%\/.\w-_]*)?\??(?:[-\+=&;%@.\w_]*)#?(?:[\w]*))?)$/g;

export function isUrl(path) {
  return reg.test(path);
}

// 定义允许含有的字符
function isLegal(str){
  
  const reg = /^[#￥^&*$!！]$/i
  if (reg.test(str))
    return false;
  return true;
}

// 检测字符串是否含有非法字符
export function isStrLegal(str1){
  if(str1==undefined || str1.trim().length === 0 )
    return false;
  for (let i=0; i<str1.length; i++) {
     if (!isLegal(str1.charAt(i))){
      return false;
     }
  }
  return true;
}

export function crowdNameTest(str1){
  if(str1==undefined || str1.trim().length === 0 )
    return false;
  for (let i=0; i<str1.length; i++) {
    const str = str1.charAt(i);
    if(str >= '0' && str <= '9'){
      continue;
    }
    if(str >= 'a' && str <= 'z'){
      continue;
    }
    if(str >= 'A' && str <= 'Z'){
      continue;
    }
    return false;
  }
  return true;
}

function getRelation(str1, str2) {
  if (str1 === str2) {
    console.warn('Two path are equal!');  // eslint-disable-line
  }
  const arr1 = str1.split('/');
  const arr2 = str2.split('/');
  if (arr2.every((item, index) => item === arr1[index])) {
    return 1;
  } else if (arr1.every((item, index) => item === arr2[index])) {
    return 2;
  }
  return 3;
}

export function getRoutes(path, routerData) {
  let routes = Object.keys(routerData).filter(routePath =>
    routePath.indexOf(path) === 0 && routePath !== path);
  routes = routes.map(item => item.replace(path, ''));
  let renderArr = [];
  renderArr.push(routes[0]);
  for (let i = 1; i < routes.length; i += 1) {
    let isAdd = false;
    isAdd = renderArr.every(item => getRelation(item, routes[i]) === 3);
    renderArr = renderArr.filter(item => getRelation(item, routes[i]) !== 1);
    if (isAdd) {
      renderArr.push(routes[i]);
    }
  }
  const renderRoutes = renderArr.map((item) => {
    const exact = !routes.some(route => route !== item && getRelation(route, item) === 1);
    return {
      ...routerData[`${path}${item}`],
      key: `${path}${item}`,
      path: `${path}${item}`,
      exact,
    };
  });
  return renderRoutes;
}

export const normalizeAppBehaviorData = (d) => {
  const transformed = {
    value: d.id,
    label: d.label,
    key: d.label,
  };
  if (d.children) {
    return {
      ...transformed,
      children: d.children.map(c => normalizeAppBehaviorData(c)),
    }
  } else {
    return transformed;
  }
};


export const normalizeAllAppBehaviorData = (c) => {
  const behaviorList = []
  c.map((d) => {
    if (d.children) {
      behaviorList.push({
        value: d.id,
        label: d.label,
      })
      d.children.map((j) => {
          behaviorList.push({
            value: j.id,
            label: j.label,
          })
       })
    } else {
      behaviorList.push({
        value: d.id,
        label: d.label,
      })
    }
  })
  
  return behaviorList
};

// 数组对象排序使用property 数组对象名称ArrayObject, 是否还有一层，有则填内层的对象名 isAscend true升序 false降序

export function sortArray (array, property, ArrayObject, isAscend)  {
  const compare = (property, ArrayObject) => {
    return (a, b) => {
     if(isAscend) { 
       if(ArrayObject) {
         return a[property][ArrayObject] - b[property][ArrayObject]
       }else {
        return a[property] - b[property]
       }
     }else if(ArrayObject) {
        return b[property][ArrayObject] - a[property][ArrayObject]
       }else {
        return b[property] - a[property]
       }
    }
  };
  return array.sort(compare(property, ArrayObject))
}

export function clearEmptyString(object) {
  return Object.keys(object).reduce(
    (result, key) => Object.assign(result, {
      [key]:
        object[key] === ''
          ? undefined
          : ((object[key] && typeof (object[key]) === 'object') ? clearEmptyString(object[key]) : object[key]),
    }), {}
  )
}

export function toMoment(timestamp) {
  if (Array.isArray(timestamp)) return timestamp.map(toMoment)
  return moment(timestamp)
}

export function toTimestamp(instance) {
  if (Array.isArray(instance)) return instance.map(toTimestamp)
  return moment.isMoment(instance) && instance.valueOf()
}

export function formatDateRange(value) {
  const dateRange = toTimestamp(value) || []
  return {
    beginDate: dateRange[0],
    endDate: dateRange[1],
  }
}

export function formatTime(time, preserve) {
  const formatted = new Date(time || Date.now())
  const done = () => formatted.getTime()

  const available = new Set(['second', 'minute', 'hour', 'date', 'day', 'month', 'year'])
  if (!available.has(preserve)) return done()
  
  formatted.setMilliseconds(0)
  if (preserve === 'second') return done()

  formatted.setSeconds(0)
  if (preserve === 'minute') return done()

  formatted.setMinutes(0)
  if (preserve === 'hour') return done()

  formatted.setHours(0)
  if (preserve === 'date' || preserve === 'day') return done()

  formatted.setDate(1)
  if (preserve === 'month') return done()

  formatted.setMonth(1)

  return done() 
}

export function formatDate(time, adjust = 0) {
  const date = formatTime(time, 'date')
  const oneDay = 24 * 60 ** 2 * 1000
  return date + (adjust ? adjust * oneDay : 0)
}

export const basicCardStyle = {
  bordered: false,
  bodyStyle: {
    padding: '16px 24px',
  },
}

export const mapify = (list, alias = []) => (list || []).reduce((result, item) => ({ ...result, [item[alias[0] || 'key']]: item[alias[1] || 'value'], ...(item.children && mapify(item.children, alias)) }), {})

export function mapColumnCategory(columnCategory, map = ['code', 'value']) {
  return (columnCategory || [])
    .reduce((outer, group) => ({
      ...outer,
      ...group.secondList.reduce((inner, item) => ({ ...inner, [item[map[0]]]: item[map[1]] }), {}),
    }), {})
}

export const mixStyle = (origin, cover) => {
  const inferior = origin || {};
  const priority = cover || {};
  return {
    className: classNames(inferior.className, priority.className),
    style: {
      ...inferior.style,
      ...priority.style,
    },
  }
}

export const findCity = (e) => {
  return cityType.find(item => item.type === e).value
}

// id递归查找，(用在创意分类直传子id，返回父id，子id)
export const getTreeLineArr = (targetUid, arr) => {
  if (targetUid instanceof Array) {
    targetUid = targetUid.pop()
  }
  let result;
  const recursiveResolveTree = (uidLineString, parentUid, childrenList) => {
    if (parentUid) uidLineString = uidLineString === '' ? String(parentUid) : `${uidLineString},${parentUid}`;
    childrenList.forEach(({ value, children }) => {
      if (value === targetUid) {
        result = uidLineString === '' ? String(value) : `${uidLineString},${value}`;
      }
      if (children && children.length) {
        recursiveResolveTree(uidLineString, value, children);
      }
    })
  }

  recursiveResolveTree('',undefined, arr);
  return result === undefined ? [] : result.split(',').map(item => (Number(item)));
} 

// 投放时间计算
export const getTimeSeriesList = (timeSeries) => {
  if (timeSeries == null) {
    return null;
  }
  let timeSeriesShort = timeSeries;
  const timeSeriesList = []
  if (timeSeries.length === 336) {
      timeSeriesShort = getTimeSeriesFrom(timeSeries);
  }
  if (timeSeriesShort.length == 168) {
    for (let weekDay = 0; weekDay < 7; weekDay++) {
        const timeSerie = timeSeriesShort.substring(weekDay * 24, (weekDay + 1) * 24);
        let unit = "";
        switch (weekDay) {
            case 0 :
              unit = unit.concat("星期一 ");
                break;
            case 1 :
              unit = unit.concat("星期二 ");
                break;
            case 2 :
              unit = unit.concat("星期三 ");
                break;
            case 3 :
              unit = unit.concat("星期四 ");
                break;
            case 4 :
              unit = unit.concat("星期五 ");
                break;
            case 5 :
              unit = unit.concat("星期六 ");
                break;
            case 6 :
              unit = unit.concat("星期日 ");
                break;
            default:
                break;
        }
        unit = unit.concat(getDayTimeSeries(timeSerie));
        timeSeriesList.push(unit.toString());
      }
  }
  return timeSeriesList;
}

const getTimeSeriesFrom = (dtoTimeSeries) => {
  if (dtoTimeSeries == null) {
    return null;
  }
  if (dtoTimeSeries.length == 168) {
    return dtoTimeSeries;
  }
  if (dtoTimeSeries.length === 336) {
      let timeSeries = '';
      const chars = dtoTimeSeries.split('');
      for (const i = 0; i < chars.length; i+= 2) {
        timeSeries = timeSeries.concat(chars[i]);
      }
      return timeSeries.toString();
  }
  return "广告投放时段错误，请检查广告投放时段！";
}

const getDayTimeSeries = (dayTimeSeries) => {
  let time = ""
  let isFirst = true;
  for (let hour = 0; hour < 24; hour ++) {
      const c = dayTimeSeries.charAt(hour);
      if (c == '1') {
          if (isFirst) {
            time = time.concat(`${hour  }:00-`);
              isFirst = false;
          } else if (hour == 23 || dayTimeSeries.charAt(hour + 1) == '0') {
                time = time.concat(`${hour + 1  }:00 `);
                  isFirst = true;
              }
      }else if (c == '0'){
        if (!isFirst) {
          if (dayTimeSeries.charAt(hour - 1) != '0'){
            time = time.concat(`${hour  }:00 `);
            isFirst = true;
          }
        }
      }
  }
  return time.toString();
}

// 获取一个在线图片占用的存储空间
export const getImageSize = async (url) => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.onload = function() {
      const xhr = new XMLHttpRequest();
      xhr.open('HEAD', img.src, true);
      xhr.onreadystatechange = function(){
        if (xhr.readyState === 4){
          if (xhr.status === 200){
            resolve(xhr.getResponseHeader('Content-Length'));
          } else {
            reject(`Failed to fetch the image. Status code: ${  xhr.status}`);
          }
        }
      };
      xhr.send();
    };
    img.src = url.replace(/^http:/, 'https:');
  });
}

// 获取一个在线视频占用的存储空间
export const getVideoSize = async (url) => {
  try {
    const response = await fetch(url, {
      method: 'HEAD',
    });
    const contentLength = response.headers.get('content-length');
    if (contentLength) {
      return parseInt(contentLength, 10);
    } else {
      throw new Error('无法获取视频大小');
    }
  } catch (error) {
    console.error('获取视频大小时出错：', error);
    throw error;
  }
}

// 获取图片类型
export const getFileType = (url) => {
  const extension = url.split('.').pop();
  return extension.toLowerCase(); // 将扩展名转换为小写形式
}
